<script>
    export let detailMbl;
</script>
<section>
    {#each detailMbl as data}
    <div class="faq-div_mbl">
        <div class="faq-heading_mbl">
            <div style="margin-left: 0.332vw;">
                <p
                    style="font-size:3.056vw; font-weight:600; color:#00204B;"
                >
                    -
                </p>
            </div>
            <div style="margin-left: 3.776vw; margin-top:1.389vw;">
                <p
                    style="font-size: 3.056vw; font-weight:600; color:#00204B;margin:0;padding:0;"
                >
                    {data.heading}
                </p>
            </div>
        </div>
        <div class="faq-text_mbl">
            <p
                style="font-size:3.056vw; font-weight:400; color:#00204B;
                width:75.75vw;
                margin-top:1.257vw;margin-left:4.307vw;margin: 1.47vw 0vw 6.724vw 5.9vw;padding:0;"
            >
                {data.text}
            </p>
        </div>
    </div>
{/each}
</section>
<style>
        .faq-div_mbl {
            width: 75.278vw;
            margin-top: 1vw;
            margin-left: 8vw;
    }
        .faq-heading_mbl {
        display: flex;
        align-items: baseline;
    }
</style>